/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable max-lines-per-function */
import React from "react";
import { Typography, Row, Col } from "antd";
import { CHOrderSummaryHeaderProps } from "interfaces/ClientInterface/PerlickClientInterface/ICHOrder";
import { perlickConstant } from "config/Perlick.Constant";
const { Text } = Typography;

/**
 * @param {string} accounts - The name of account
 * @param {string} user - The name of user
 * @param {string} orderStatus - status of order
 * @param {string} total - total value of the order
 * @returns this functional component returns a JSX element that renders
 * header for order summary collapse.
 */
export default function OrderSummaryHeader({ orderDetails }: CHOrderSummaryHeaderProps) {
  return (
    <Row>
      <Col md={19} className="d-flex">
        <Text className="m-0 accordion-heading">
          <b>Order Information </b>|
        </Text>
        <Text className="m-0 accordion-heading ">
          <b className="mx-4">{perlickConstant.Customer}</b> :{" "}
          <span className="font-500">{orderDetails.Soldtoname}</span>
        </Text>
      </Col>
    </Row>
  );
}
